import assert = require("assert");
import { Context } from "../src/context";
import { OrderUtil } from "../src/order";
import { OrderInfo } from "../src/types";

describe("OrderUtil", () => {

  it("should be able to calculate order's hash", () => {
    const context = new Context(0,
                                0,
                                "",
                                "",
                                "",
                                "",
                                "",
                                "",
                                "",
                                "0x50467574de9b55003236F05Bf24fb0022d8DDaA7",
                                1000,
                                0);
    const orderUtil = new OrderUtil(context);

    const order: OrderInfo = {
      tokenS: '0x4573b753c9F61C661aC8cA7d2f277199Ca495FA7',
      tokenB: '0x50467574de9b55003236F05Bf24fb0022d8DDaA7',
      amountS: 1000000000000000000,
      amountB: 1e+21,
      balanceS: 1e+26,
      balanceFee: 1e+26,
      balanceB: 1e+26,
      owner: '0x94379bF0b21fdc5f40023177BC00F9eE8BB8bBc1',
      feeAmount: 1000000000000000000,
      dualAuthSignAlgorithm: 0,
      dualAuthAddr: '0x15d6D8a0cff888B9D3f6B2D916Dc2A19b9652310',
      allOrNone: false,
      validSince: 1545032699,
      walletAddr: '0x6883818661dd47b0d6b3184AA781FE837f7c9335',
      walletSplitPercentage: 10,
      signAlgorithm: 0,
      version: 0,
      validUntil: 0,
      tokenRecipient: '0x94379bF0b21fdc5f40023177BC00F9eE8BB8bBc1',
      feeToken: '0x50467574de9b55003236F05Bf24fb0022d8DDaA7',
      waiveFeePercentage: 0,
      tokenSFeePercentage: 0,
      tokenBFeePercentage: 0,
      tokenTypeS: 0,
      tokenTypeB: 0,
      tokenTypeFee: 0,
      trancheS: '0x0000000000000000000000000000000000000000000000000000000000000000',
      trancheB: '0x0000000000000000000000000000000000000000000000000000000000000000',
      transferDataS: '0x',
      tokenSpendableS: { index: 0 },
      tokenSpendableFee: { index: 1 },
    };
    const hash = orderUtil.getOrderHash(order);
    console.log("hash:", hash);
    assert(true, "true");
  });

});
